import React from 'react';
import { AlertTriangle, FileWarning, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const DocumentValidityWarning = ({ documentsValidity }) => {
  const navigate = useNavigate();

  // DEBUG: Afficher les données reçues dans la console
  console.log('DocumentValidityWarning - données reçues:', documentsValidity);

  // Ne rien afficher si les documents sont valides ou si pas de donnees
  if (!documentsValidity || documentsValidity.is_valid) {
    console.log('DocumentValidityWarning - pas d\'avertissement (is_valid:', documentsValidity?.is_valid, ')');
    return null;
  }

  const { warning_message, invalid_documents, confidence } = documentsValidity;

  // S'assurer que invalid_documents est un tableau
  const safeInvalidDocs = Array.isArray(invalid_documents) ? invalid_documents : [];

  return (
    <div className="mb-8">
      <div className="p-6 bg-orange-50 rounded-lg border-2 border-orange-300">
        {/* Header */}
        <div className="flex items-start mb-4">
          <AlertTriangle size={24} className="text-orange-600 mr-3 flex-shrink-0 mt-1" />
          <div>
            <h3 className="text-lg font-semibold text-orange-800">
              Documents potentiellement non pertinents detectes
            </h3>
            <p className="text-sm text-orange-600 mt-1">
              Confiance de detection : {Math.round((1 - (confidence || 0)) * 100)}%
            </p>
          </div>
        </div>

        {/* Message d'avertissement */}
        {warning_message && (
          <p className="text-orange-700 mb-4 leading-relaxed">
            {warning_message}
          </p>
        )}

        {/* Liste des fichiers invalides */}
        {safeInvalidDocs.length > 0 && (
          <div className="mb-4">
            <p className="text-sm font-medium text-orange-800 mb-2">
              Fichiers concernes :
            </p>
            <ul className="space-y-2 bg-white/50 rounded-lg p-3">
              {safeInvalidDocs.map((doc, index) => (
                <li key={index} className="flex items-start text-sm">
                  <FileWarning size={16} className="text-orange-500 mr-2 flex-shrink-0 mt-0.5" />
                  <div>
                    <span className="font-medium text-orange-800">{doc.filename}</span>
                    {doc.reason && (
                      <span className="text-orange-600 ml-2">
                        - {doc.reason}
                      </span>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Actions */}
        <div className="flex flex-wrap gap-3 mt-4">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-orange-700 bg-white border border-orange-300 rounded-lg hover:bg-orange-50 transition-colors"
          >
            <RefreshCw size={16} className="mr-2" />
            Soumettre de nouveaux documents
          </button>
        </div>

        {/* Note explicative */}
        <p className="text-xs text-orange-600 mt-4 italic border-t border-orange-200 pt-3">
          Note : L'analyse a quand meme ete effectuee avec les documents fournis.
          Si vos documents sont corrects (lettres de mise en demeure, commandements de payer, etc.),
          vous pouvez ignorer cet avertissement. Dans le cas contraire, veuillez soumettre
          les documents relatifs a votre dossier de recouvrement.
        </p>
      </div>
    </div>
  );
};

export default DocumentValidityWarning;
